import { FilterShop } from "../../../../../shop/frontend/web/js/classes/FilterShop.js";

let isSwitch = false;

/**
 *  Класс описывающий реализацию фильтра
 * @extends FilterShop
 */
export class Filter extends FilterShop {
	constructor() {
		super();
		this.$filterClear = $("#js-filter-clear");
		this.$filters = $(".js-filter-input");
		this.$items = $("#js-event-items");
		this.$more = $("#js-more");
		this.$message = $("#js-events-message");
		this.$calendarInput = $(".js-date-filter");
		this.$calendarLabel = $("#js-filter-label");
		this.$filterTitle = $("#js-filter-title");
		this.$filterWrapper = $("#js-filter-wrapper");
		this.$filterSwitch = $("#js-filter-switch");
		this.$filterSwitchInput = $("#js-switch-input");
	}

	setActionMore() {
		this.$more.on("click", () => {
			this.page++;
			this.getRequest("append");
		});

		this.$filterSwitchInput.on("change", e => {
			const element = $(e.currentTarget);
			this.page = 0;

			if (!element.is(":checked")) {
				this.hasParking = false;
				this.$filterSwitch.removeClass("active");
				this.$filterClear.addClass("active");
			} else {
				this.$filterSwitch.addClass("active");
				this.hasParking = true;
			}

			this.getRequest();
		});
	}
}
